/**
 * Beträge der Kostenposition in Eingabefeldern – im Nachweis-Detail und im Dialog einer Aktion.
 */

/** Leeres Feld bedeutet "nicht gepflegt" und wird als null gespeichert, nicht als 0. */
export const alsBetrag = (value: string): number | null => {
  const trimmed = value.trim();
  if (trimmed === "") return null;
  const parsed = parseFloat(trimmed);
  return isNaN(parsed) ? null : parsed;
};

export const betragAlsFeldwert = (betrag: number | null | undefined): string =>
  betrag == null ? "" : String(betrag);
